import ProjectPricing from "../../../Companies/SelectedCompany/CompanyPrograms/CreateProgram/ProjectPricing/ProjectPricing";
import { ProjectsAvailableSessionTypes } from "../../../../types/Projects";
import { Project } from "../../../../types/Company";
import { ProjectFormController } from "../useProjectFormController";
import s from "../ProjectFormPage.module.css";

type PricingStepProps = {
  controller: ProjectFormController;
  project: Project | null;
};

const PricingStep = ({ controller, project }: PricingStepProps) => {
  return (
    <div className={s.stepPanel}>
      <div className={s.section}>
        <h2 className={s.sectionTitle}>Pricing</h2>
        <p className={s.sectionText}>
          Configure pricing, discounts, taxes, and purchase limits for selected
          Project types.
        </p>
      </div>

      {!controller.selectedProjectTypes.length ? (
        <div className={s.emptyState}>
          Select a Project type in Specialist Scope to configure pricing.
        </div>
      ) : (
        controller.selectedProjectTypes.map((type) => (
          <ProjectPricing
            pricingType={
              type === ProjectsAvailableSessionTypes.SESSION
                ? "sessions"
                : "packages"
            }
            setNewProgramData={controller.setProjectData}
            newProgramData={controller.projectData}
            levels={controller.specialistLevels}
            programData={project ?? undefined}
            staticPackages={controller.staticPackages}
            key={type}
          />
        ))
      )}
    </div>
  );
};

export default PricingStep;
